import { MarkEmailRead as MarkEmailReadIcon } from '@mui/icons-material';

const MarkEmailRead = (): JSX.Element => <MarkEmailReadIcon fontSize="inherit" />;

export default MarkEmailRead;
